import { useEffect, useState } from "react";
import { EVENT_OWN_CID_CHANGED, KEY_OWN_CID } from "./challengeModel";


export const useOwnCid = () => {
  const [ownCid, setOwnCid] = useState(() => localStorage.getItem(KEY_OWN_CID) || '');

  useEffect(() => {
    const storageHandler = (e: StorageEvent) => {
      console.log("useOwnCide StorageEvent:", e);
      if (e.key === KEY_OWN_CID) {
        setOwnCid(e.newValue || '');
      }
    };
    window.addEventListener('storage', storageHandler);
    const customHandler = (e: CustomEvent) => {
      console.log("useOwnCide CustomEvent:", e);
      setOwnCid(e.detail.cid || '');
    }
    window.addEventListener(EVENT_OWN_CID_CHANGED, customHandler);
    return () => {
      window.removeEventListener('storage', storageHandler);
      window.removeEventListener(EVENT_OWN_CID_CHANGED, customHandler);
    }
  }, []);

  const updateOwnCid = (cid: string) => {
    localStorage.setItem(KEY_OWN_CID, cid);
    setOwnCid(cid); // update local state too
    window.dispatchEvent(new CustomEvent(EVENT_OWN_CID_CHANGED, { detail: { cid } }));
  };

  return {
    ownCid, 
    setOwnCid: updateOwnCid
  } as const;
}